'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaYelp = function FaYelp(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.3 29.4v2.9q-0.1 6.5-0.2 6.8-0.2 0.7-1.1 0.9-1.2 0.2-4.1-0.9t-3.6-2q-0.3-0.3-0.4-0.8 0-0.2 0.1-0.5 0.1-0.3 0.8-1.1t4-4.8q0 0 1.4-1.6 0.3-0.4 0.8-0.5t1.1 0.1q0.6 0.2 0.9 0.6t0.3 0.9z m-3.4-5.6q0 1.3-1.1 1.6l-2.7 0.9q-6.1 1.9-6.5 1.9-0.8 0-1.2-0.8-0.3-0.5-0.4-1.6-0.2-1.7 0-3.8t0.7-2.7 1.2-0.8q0.3 0 4.5 1.8 1.6 0.6 2.6 1l1.9 0.8q0.5 0.2 0.8 0.7t0.2 1z m18.5 6.7q-0.2 1.2-2.1 3.6t-3 2.8q-0.8 0.3-1.4-0.2-0.3-0.2-4.1-6.4l-1.1-1.7q-0.3-0.5-0.2-1t0.4-1q0.8-1 1.9-0.6 0 0 2.6 0.9 4.6 1.4 5.4 1.8t1.1 0.4q0.6 0.5 0.5 1.4z m-15-14.1q0.1 2.2-1.2 2.7-1.3 0.4-2.6-1.6l-8.4-13.3q-0.2-0.8 0.4-1.4 0.9-1 4.6-2t5-0.7q0.9 0.2 1.1 1 0.1 0.4 0.5 6.8t0.6 8.5z m14.7 2.4q0.1 0.8-0.5 1.3-0.4 0.2-7.4 1.9-1.5 0.3-2 0.5l0 0q-0.5 0.1-1-0.1t-0.8-0.7q-0.7-1.1 0-2 0 0 1.6-2.2 2.8-3.9 3.4-4.6t0.7-0.9q0.7-0.4 1.5 0 1.1 0.5 2.7 3t1.8 3.7v0.1z' })
        )
    );
};

exports.default = FaYelp;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/yelp.js
// module id = 1141
// module chunks = 168707334958949